<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <div v-if="!loading">
        <v-container v-if="item.title" class="py-10 py-md-13 py-lg-16 item">
          <TitleWidget class="text-center">{{ item.title }}</TitleWidget>
          <v-row class="mt-10 mt-md-16">
            <v-col cols="12" sm="6">
              <div
                v-if="item.text"
                class="grey--text text--darken-1 ck-content item-text"
                v-html="item.text"
              ></div>
            </v-col>
            <v-col cols="12" sm="6">
              <img
                v-if="item.img"
                class="d-block item-img"
                :src="files + item.img + '?resize=1&w=960'"
                :alt="item.title"
                width="100%"
              />
            </v-col>
          </v-row>
        </v-container>

        <ShippingBannerSection />
      </div>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import TitleWidget from "../components/widgets/TitleWidget.vue";
import ShippingBannerSection from "../components/sections/ShippingBannerSection.vue";

const _config = {
  mod: "transport",
};

export default {
  data: () => ({
    loading: true,
  }),
  created() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
  },
  components: {
    LoadingWidget,
    TitleWidget,
    ShippingBannerSection,
  },
};
</script>
